/**
 * Выбор саб-вкладки («В ожидании»/«Выставленные») после обновления счётчиков
 * (смена линии/уровня): остаёмся в текущей вкладке, если в ней есть элементы
 * или пусто везде; переключаемся на соседнюю только когда текущая пуста,
 * а соседняя — нет (фидбек 2026-07-08).
 */
export const resolveStickyTab = (
  currentTab: number,
  counts: Record<number, number>,
): number => {
  if ((counts[currentTab] ?? 0) > 0) return currentTab
  const filledSibling = Object.keys(counts)
    .map(Number)
    .find(tab => tab !== currentTab && (counts[tab] ?? 0) > 0)
  return filledSibling ?? currentTab
}
